import { createContext, useContext, type ReactNode } from "react";

export interface DocumentLinkContextValue {
  linkType: string;
  linkTargetId: number;
  customerId: number;
}

const DocumentLinkContext = createContext<DocumentLinkContextValue | null>(
  null
);

export function useDocumentLinkContext(): DocumentLinkContextValue {
  const context = useContext(DocumentLinkContext);
  if (!context) {
    throw new Error(
      "useDocumentLinkContext must be used within a DocumentLinkProvider"
    );
  }
  return context;
}

interface DocumentLinkProviderProps {
  linkType: string;
  linkTargetId: number;
  customerId: number;
  children: ReactNode;
}

export function DocumentLinkProvider({
  linkType,
  linkTargetId,
  customerId,
  children
}: DocumentLinkProviderProps) {
  return (
    <DocumentLinkContext.Provider
      value={{ linkType, linkTargetId, customerId }}
    >
      {children}
    </DocumentLinkContext.Provider>
  );
}
